import { combineReducers } from 'redux';

import bar from './bar/reducer';
import results from './results/reducer';
import paging from './paging/reducer';
import tabs from './tabs/reducer';

export default combineReducers({
  bar,
  results,
  paging,
  tabs
});




/** WEBPACK FOOTER **
 ** ./src/members/state/search/reducer.js
 **/